export class ClientesComercio {
  id: number;
  comercio: string;
  idClienteEntidad: string;
  fechaHora: string;
  nombre: string;
  apellido: string;
  telefono: string;
  nroDocumento: string;
  fechaNacimiento: string;
  verificado: boolean;
  sincronizacionEstado: string;

  constructor(id?: number, comercio?: string, idClienteEntidad?: string, fechaHora?: string, nombre?: string, apellido?: string, telefono?: string, nroDocumento?: string, fechaNacimiento?: string, verificado?: boolean, sincronizacionEstado?: string) {
    this.id = id ?? null;
    this.comercio = comercio ?? '';
    this.idClienteEntidad = idClienteEntidad ?? '';
    this.fechaHora = fechaHora ?? '';
    this.nombre = nombre ?? '';
    this.apellido = apellido ?? '';
    this.telefono = telefono ?? '';
    this.nroDocumento = nroDocumento ?? '';
    this.fechaNacimiento = fechaNacimiento ?? '';
    this.verificado = verificado ?? false;
    this.sincronizacionEstado = sincronizacionEstado ?? '';
  }
}
